import React from 'react'
import ValidateForm from "../../helpers/ValidateForm";
import GetDataApi from "../../helpers/GetDataApi";
import Api from "../../helpers/Api";
import Env from "../../config/env";
import AppToast from "../../ui/AppToast";
import Redirect from "../../helpers/Redirect";
import ValidateEmail from "../../helpers/ValidateEmail";
import UpdateProfileForm from "./UpdateProfileForm";
import AppBreadcrumbs from "../../components/AppBreadcrumbs";
import Session from "../../helpers/Session";
import ValidateMinTel from "../../helpers/ValidateMinTel";
import {withRouter} from 'react-router';
import AlertVerifyEmail from "./AlertVerifyEmail";

class UpdateProfile extends React.Component {
    terceroID = null;
    state = {
        form: {
            documentoTipoID: {
                key: 'documentoTipoID',
                value: '',
                required: true
            },
            terceroDocumento: {
                key: 'terceroDocumento',
                value: '',
                required: true
            },
            terceroNombre1: {
                key: 'terceroNombre1',
                value: '',
                required: true
            },
            terceroNombre2: {
                key: 'terceroNombre2',
                value: '',
                required: false
            },
            terceroApellido1: {
                key: 'terceroApellido1',
                value: '',
                required: true
            },
            terceroApellido2: {
                key: 'terceroApellido2',
                value: '',
                required: false
            },
            terceroMail: {
                key: 'terceroMail',
                value: '',
                required: true
            },
            terceroTel: {
                key: 'terceroTel',
                value: '',
                required: false
            },
            terceroCel: {
                key: 'terceroCel',
                value: '',
                required: false
            },
            terceroDireccion: {
                key: 'terceroDireccion',
                value: '',
                required: true
            },
        },
        url: '',
        loadData: {
            documentTypes: []
        },
        openModal: false,
    };

    componentDidMount() {
        this.loadForm();
    }

    loadForm = async () => {

        await this.getDocumentTypes();

        const userData = Session.getLogin();
        this.terceroID = userData.terceroID;

        this.setState({
            form: {
                documentoTipoID: {
                    ...this.state.form.documentoTipoID,
                    value: userData.documentoTipoID,
                },
                terceroDocumento: {
                    ...this.state.form.terceroDocumento,
                    value: userData.terceroDocumento,
                },
                terceroNombre1: {
                    ...this.state.form.terceroNombre1,
                    value: userData.terceroNombre1,
                },
                terceroNombre2: {
                    ...this.state.form.terceroNombre2,
                    value: userData.terceroNombre2,
                },
                terceroApellido1: {
                    ...this.state.form.terceroApellido1,
                    value: userData.terceroApellido1,
                },
                terceroApellido2: {
                    ...this.state.form.terceroApellido2,
                    value: userData.terceroApellido2,
                },
                terceroMail: {
                    ...this.state.form.terceroMail,
                    value: userData.terceroMail,
                },
                terceroTel: {
                    ...this.state.form.terceroTel,
                    value: userData.terceroTel,
                },
                terceroCel: {
                    ...this.state.form.terceroCel,
                    value: userData.terceroCel,
                },
                terceroDireccion: {
                    ...this.state.form.terceroDireccion,
                    value: userData.terceroDireccion,
                },
            },
        });
    }

    getDocumentTypes = async () => {
        const data = await Api.get(`${Env.UrlSeguridad}/getDocumentoTipo`);
        if (data.cod === '1') {
            this.setState({
                loadData: {
                    documentTypes: data.DocumentoTipo
                }
            });
        } else {
            AppToast(data.message, false);
        }
    }

    handleSubmit = async (e) => {
        e.preventDefault();

        // Validaciones del formulario
        if (!this.validate()) {
            return;
        }

        this.setState({openModal: true});
    }

    validate = () => {
        // Valida los campos obligatorios
        if (!ValidateForm(this.state.form)) {
            return false;
        }

        // Valida que ingrese mínimo un número
        if (!ValidateMinTel(this.state.form.terceroTel.value, this.state.form.terceroCel.value)) {
            return false;
        }

        // Valida formato del email
        if (!ValidateEmail(this.state.form.terceroMail.value)) {
            AppToast('El email no tiene un formato válido!', false);
            return false;
        }

        return true;
    }

    handleChange = (e) => {
        const {value, name} = e.target;

        this.setState((statePrev) => {
            return {
                form: {
                    ...statePrev.form,
                    [name]: {
                        ...statePrev.form[name],
                        value: value
                    }
                }
            }
        });
    }

    handleCloseModal = () => {
        this.setState({openModal: false});
    }

    save = async () => {

        this.handleCloseModal();

        let params = GetDataApi(this.state.form);
        params = {
            ...params,
            terceroID: this.terceroID, // Se agrega el id del tercero para realizar la modificacion de datos
        };

        const data = await Api.post(`${Env.UrlSeguridad}/postTercero`, params);
        if (data.cod === '1') {
            AppToast('Los datos se actualizaron con éxito!', true);
            Session.update(params); // Se actulizan los datos en la session
            this.setState({
                url: '/accounts'
            });
        } else {
            AppToast(data.msg, false);
        }
    }

    render() {
        return (
            <div>
                <Redirect url={this.state.url}/>

                <AppBreadcrumbs
                    links={[
                        {
                            url: 'accounts',
                            label: 'Cuentas'
                        }
                    ]}
                    actual='Actualizar Datos'
                />

                <UpdateProfileForm
                    form={this.state.form}
                    loadData={this.state.loadData}
                    onChange={this.handleChange}
                    onSubmit={this.handleSubmit}
                />

                <AlertVerifyEmail
                    save={this.save}
                    openModal={this.state.openModal}
                    onCloseModal={this.handleCloseModal}
                />

            </div>
        );
    }

}

export default withRouter(UpdateProfile)
